module.exports = __webpack_public_path__ + "02_short_yellow.07b95064.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_short_yellow.png
// module id = dTzo
// module chunks = 0